import { RootPage } from '../page';
import { checkExtensionIsInstalledAsync, getExtensionDownloadLink } from '../../../react/utils/chrome-extension';
import $api from '../../api';

class DashboardOverviewView extends RootPage {
    constructor() {
        super();

        this.isReceiving = ko.observable();
        this.isExtensionInstalled = ko.observable();

        this.chromeExtensionDownloadLink = getExtensionDownloadLink();

        this.mobileOverlay = ko.observable(isMobileBrowser() && !window.auth.isImp);
    }

    onInit() {
        this.isReceiving(this.getServerSideData('isReceiving'));

        checkExtensionIsInstalledAsync().then(res => {
            this.isExtensionInstalled(res);
        });
    }

    finishOnboarding(reason) {
        TRACK_EVENT('Projects', 'Dashboard checklist dismissed', { reason });

        $api.projects.setIsInstalled(
            { projectCode: auth.project.UniqueCode },
            {},
            (resp) => {
                window.location.reload();
            }
        );
    }
}

export default DashboardOverviewView;